import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  isStale: true,
  latest_fetch: '',
  type: 'animalTypes',
  pageLayout: 'LayoutStructureTable',
  canEdit: false,
  canView: false,
  inlineEdit: true,
  modelLabels: {
    single: 'Category',
    plural: 'Categories'
  },
  filterOverrides: [],
  aliasField: 'name',
  relations: [
    {
      name: 'animals',
      translate: 'animals',
      label: 'Species',
      value: 'animals',
      storename: 'animals',
      export: false
    }
  ],
  all: {},
  active: false,
  searchFields: ['name'],
  bound: {
    name: ''
  },
  filter: {},
  quickFilters: [],
  stub: {},
  include: ''
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
